import { ContactIcon, EmailIcon, LocationIcon } from "../../assets";
import { ContactUsForm, Footer, Header } from "../../components";
import { HeaderType } from "../../components/Header/Header";
import { ContactItemStyle, ContactUsStyle } from "./ContactUs.style";

const ContactItem = ({
  icon,
  content,
}: {
  icon: React.ReactNode;
  content: React.ReactNode;
}) => {
  return (
    <ContactItemStyle>
      {icon}
      <p className="item-content">{content}</p>
    </ContactItemStyle>
  );
};

const ContactUs = () => {
  return (
    <>
      <ContactUsStyle>
        <Header
          heading="Contact Us"
          image="/images/banners/contact-us.png"
          type={HeaderType.inner}
        />

        <article className="contact-us-wrapper">
          <section>
            <ContactUsForm />
          </section>

          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3428.7500522259415!2d-97.80921112533755!3d30.7535216846293!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865ad35fe313701d%3A0xe531f1ed9d8acd1f!2s500%20Rawhide%20Ln%2C%20Florence%2C%20TX%2076527%2C%20USA!5e0!3m2!1sen!2s!4v1787144025536!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="strict-origin-when-cross-origin"
            title="Super Hauling Inc Map"
          />
        </article>

        <section className="contacts">
          <ContactItem
            icon={<ContactIcon />}
            content={<a href="tel:+18886939563">(888) 693-9563</a>}
          />

          <ContactItem
            icon={<EmailIcon />}
            content={
              <a href="mailto:info@superspeedhauling.us">
                info@superspeedhauling.us
              </a>
            }
          />

          <ContactItem
            icon={<LocationIcon />}
            content="500 Rawhide Ln, Florence, TX 76527"
          />
        </section>
      </ContactUsStyle>

      <Footer />
    </>
  );
};

export default ContactUs;


